import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
import IModal from '@/js/components/molecules/IModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BasicDialog',
  props: {
    hasUnderline: { type: Boolean }
  },
  setup(__props: any) {


const isShow = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.wrapper)
  }, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass([_ctx.hasUnderline && _ctx.$style.underline]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isShow.value = true))
    }, [
      _renderSlot(_ctx.$slots, "link")
    ], 2),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createVNode(IModal, {
      modelValue: isShow.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isShow).value = $event)),
      width: "660px"
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "dialog")
      ]),
      _: 3
    }, 8, ["modelValue"])
  ], 2))
}
}

})